module.exports = __webpack_public_path__ + "img/jskfq.60667532.png";